import axios from "axios";

class UseGE1 {
  async getCategory(ge: string) {
    return await axios.post(`use-ge/getge`, { ge });
  }
}
const UseGE = new UseGE1();
export default UseGE;
